import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=06ee7969&scoped=true"
import script from "./Asignacion.vue?vue&type=script&lang=js"
export * from "./Asignacion.vue?vue&type=script&lang=js"
import style0 from "./Asignacion.vue?vue&type=style&index=0&id=06ee7969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee7969",
  null
  
)

export default component.exports